import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { OperationResourceAllocations, TId } from 'src/app/models';

@Component({
    selector: 'app-resource-allocation-add',
    templateUrl: './resource-allocation-add.component.html',
    styleUrl: './resource-allocation-add.component.sass',
    standalone: false
})
export class ResourceAllocationAddComponent extends GenericCrudAddComponent<OperationResourceAllocations>{

  protected override async preFetch(): Promise<void> {
    this.resource = this.api.resources.product.routingOperationsResourceAllocations(this.initialFormValues.routingId!, this.initialFormValues.operationId!);
  }
  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      setup: ['0s'],
      process:['1h'],
      teardown: ['0s'],
      cycleQuantity: [1],
    });
    return group;
  }

  protected override async mapFormEntity(): Promise<Partial<OperationResourceAllocations>> {
    const raw = this.form?.value;

    return {
      setup: this.formatTime(raw.setup),
      process: this.formatTime(raw.process),
      teardown:this.formatTime(raw.teardown),
      cycleQuantity: raw.cycleQuantity,
    };
  }

  formatTime(input: string): string {
    const hoursMatch = input.match(/(\d+)\s*h/);
    const minutesMatch = input.match(/(\d+)\s*m/);
    const secondsMatch = input.match(/(\d+)\s*s/);

    const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
    const seconds = secondsMatch ? parseInt(secondsMatch[1], 10) : 0;

    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    return `${hh}:${mm}:${ss}`;
  }

}
